import {clearHTML} from "./helpers"


export function filterAdvices(advices_data) {


    //Retrieve the user selected highlight's norm
    if(localStorage.getItem('advicePreSearchTerm')){
        const userSelectedNorm = localStorage.getItem('advicePreSearchTerm');
        //Filter Advices based on user selected highlight | annotation's AI-Tag
        advices_data = advices_data.filter((item) => clearHTML(item.norm) === userSelectedNorm)
        localStorage.removeItem('advicePreSearchTerm')
    }

    return advices_data
}
